
/**
 * 截取指定字符最后一次出现的位置前面或后面的内容
 * @param text 
 * @param state 0前 1后
 * @param str 指定字符
 * @return String
 */
export const getLastCaption = (text, state, str) => {
    var index = text.lastIndexOf(str);
    if(state == 0){
        text = text.substring(0, index);
    }else {
        text = text.substring(index+1, text.length);
    }
    return text;
}

/**
 * 截取指定字符第一次出现的位置前面或后面的内容
 * @param text 
 * @param state 0前 1后
 * @param str 指定字符
 * @return String
 */
export const getCaption = (text, state, str) => {
    var index = text.indexOf(str);
    if(state == 0){
        text = text.substring(0, index);
    }else {
        text = text.substring(index+1, text.length);
    }
    return text;
}